export const CONFIRM_BOX = {
  UNFOLLOW: 'unfollow',
  JOIN_GROUP_BEFORE_ACTION: 'joinGroupBeforeAction',
  GROUP_OWNER_TRANSFER: 'groupOwnerTransfer',
  GROUP_MODERATOR_OFFER: 'groupModeratorOffer',
  UNPIN_POST: 'unPinPost',
  BLOCK_USER: 'blockUser',
  DETECT_BAN_WORD: 'detectBanWord',
  VIP_FEATURE: 'vipFeature',
  MOVE_POST_TO_THREAD: 'movePostToThread',
  DEFAULT: 'default',
  LOADING: 'loading',
}
